import React from 'react';
import { useTranslation } from 'react-i18next';
import { PATIENT_CONSENT_TOKENS } from '../../../lib/data/medicalPresets';

// Editor de la plantilla del aviso de consentimiento que el bot envía al paciente
// en el primer contacto (Consultame, NER-3832, spec §Compliance P0.1). Permite
// personalizar el mensaje, insertar tokens y ver un preview con valores reales.
function PatientConsentTemplateEditor({ value, onChange, previewValues }) {
  const { t } = useTranslation();
  const pv = previewValues || {};

  const insertToken = (token) => {
    onChange(`${value || ''}${value && !value.endsWith(' ') ? ' ' : ''}${token}`);
  };

  // Reemplaza {{consultorio}} / {{email}} con los valores del wizard para el preview.
  const preview = (value || '').replace(/\{\{(consultorio|email)\}\}/g, (m, key) => {
    if (key === 'consultorio') return pv.consultorio || '[tu consultorio]';
    if (key === 'email') return pv.email || '[email de contacto]';
    return m;
  });

  return (
    <div className="med-consent-template">
      <label className="med-label" htmlFor="patient-consent-template">
        {t('setupWizardMedical.patientConsent.label', 'Aviso de privacidad al paciente (primer contacto)')}
      </label>
      <textarea
        id="patient-consent-template"
        className="sw-input med-consent-textarea"
        rows={4}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />

      <div className="med-token-row">
        <span className="sw-hint med-hint-tight">
          {t('setupWizardMedical.patientConsent.insert', 'Insertar:')}
        </span>
        {PATIENT_CONSENT_TOKENS.map((tok) => (
          <button
            key={tok}
            type="button"
            className="btn btn-secondary btn-sm med-token-btn"
            onClick={() => insertToken(tok)}
          >
            {tok}
          </button>
        ))}
      </div>

      <div className="med-consent-preview">
        <span className="med-preview-label">
          {t('setupWizardMedical.patientConsent.preview', 'Vista previa')}
        </span>
        <p className="med-preview-body">{preview}</p>
      </div>
    </div>
  );
}

export default PatientConsentTemplateEditor;
